import React, { useState, Fragment, useEffect, useRef } from 'react';

import axios from 'axios';

import styled from 'styled-components';
import { CircleMarker, Popup, GeoJSON } from 'react-leaflet';

import { getRiscoEscala } from '../../utils';

import { Table } from 'react-bootstrap';

import numeral from 'numeral';

function Producers(props) {
  const [producers, setProducers] = useState([]);
  const [selected, _selected] = useState(null)

  useEffect(() => {
    loadProducers();
  }, [props.mode]);

  const loadProducers = async () => {
    setProducers([]);
    // console.log('loadProducers');
    // TODO: TRY/CATCH
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}geo-service/producers`,
    );
    setProducers(data);
  };

  return (
    <Fragment>
      {producers.map((producer) => {
        const { gid, geojson, assoc: associacao } = producer;
        if (!geojson) return null;
        return <Producer key={gid} gid={gid} geojson={geojson} associacao={associacao} selected={selected} onSelected={_selected} {...props} />;
      })}
    </Fragment>
  );
}

const Producer = ({ gid, geojson, associacao, selected, onSelected, ...props }) => {
  const [geojson_data, _geojson_data] = useState(null);

  useEffect(() => {
    async function loadGeojson() {
      // load area influencia geojson
      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER}geo-service/producers/${gid}/geojson`,
      );

      console.log(data)
      _geojson_data(data);
    }

    if (selected === gid && !geojson_data) {
      loadGeojson()
    }
  }, [selected, geojson_data, gid])

  return (<>
    {selected === gid && !!geojson_data && <GeoJSON
      interactive={false}
      data={geojson_data}
      style={() => {
        return {
          fillColor: '#f00',
          fillOpacity: 0.1,
          color: '#f00',
          opacity: 1,
        };
      }}
    /* onmouseover={()=>console.log('hover AI', microId)} */
    // onclick={(e) => {
    //             /* console.log(e);  */ props.onInfo(microId);
    // }}
    // onAdd={({ target }) => handleAdd(microId, target)}
    ></GeoJSON>}

    <CircleMarker
      center={[
        geojson.geometry.coordinates[1],
        geojson.geometry.coordinates[0],
      ]}
      fillColor={`#${associacao?.color || '#000000'}`}
      color={selected === gid ? '#f00' : props.style.color(
        props.mode,
        getRiscoEscala(geojson.properties.risco),
      )}
      weight={selected === gid ? 2 : props.style.weight(props.mode)}
      radius={props.style.radius}
      opacity={props.style.opacity}
      fillOpacity={props.style.fillOpacity}
    >
      <PanelPopupProducer data={geojson.properties} onOpen={() => onSelected(gid)} /* onClose={() => _selected(false)} */ />
    </CircleMarker>

  </>)
}

const PanelPopupProducer = ({ data, onOpen, onClose }) => {
  const { gid, nome, seringal, municipio } = data;

  const [family, _family] = useState(null);
  const [area, _area] = useState(null);

  const pop = useRef();

  useEffect(() => {
    _family(null);
  }, [gid])

  const retrieveFamily = async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}geo-service/producers/${gid}/family`,
    );

    _family(data);
  }
  const retrieveArea = async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}geo-service/producers/${gid}/area`,
    );

    _area(data);
  }

  const handleClick = (f) => {
    pop.current.leafletElement.options.leaflet.map.closePopup();
    pop.current.leafletElement.options.leaflet.map.flyTo([f.lat, f.long]);
  }

  const handleOpen = () => {
    retrieveFamily();
    retrieveArea();
    onOpen();
  }

  return (
    <StyledPopup
      onOpen={handleOpen}
      onClose={onClose}
      ref={pop}
    >
      <div className="header">PRODUTOR</div>
      <Table className="body">
        <tbody>
          <tr>
            <td>
              <strong>NOME</strong>
            </td>
            <td>{nome}</td>
          </tr>
          {seringal && (
            <tr>
              <td>
                <strong>SERINGAL</strong>
              </td>
              <td>{seringal}</td>
            </tr>
          )}
          {municipio && (
            <tr>
              <td>
                <strong>MUNICÍPIO</strong>
              </td>
              <td>{municipio}</td>
            </tr>
          )}
          {area && (
            <tr>
              <td>
                <strong>ÁREA</strong>
              </td>
              <td>
                {numeral(area).format(
                  '0,0',
                )}
                {' '}ha
              </td>
            </tr>
          )}
          {!family && (
            <tr>
              <td colSpan={2}>
                Buscando por familiares...
              </td>
            </tr>
          )}
          {!!family && !!family.length && (
            <tr>
              <td colSpan={2}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div><strong>FAMILIARES</strong></div>
                  <div>
                    <ul style={{
                      padding: '0 15px',
                      listStyleType: 'square',
                    }}>
                      {family.map(f => (<Fragment key={f.id} >
                        {f.status === 'ativo' && <li style={{ cursor: 'pointer' }} onClick={() => handleClick(f)}><span>{f.outro_nome}</span> ({f.relacao_nome})</li>}
                        {f.status !== 'ativo' && <li><span>{f.outro_nome}</span> ({f.relacao_nome})</li>}
                      </Fragment>))}
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </StyledPopup>
  );
};
const StyledPopup = styled(Popup)`
  & .leaflet-popup-content-wrapper {
    border-radius: 5px !important;
  }
  & .leaflet-popup-content {
    margin: 0;
  }
  & .header {
    margin: 13px 1px 1px 1px;
    padding: 5px;
    background-color: #333;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
  & a.leaflet-popup-close-button {
    color: #333 !important;
    background-color: #fff;
    padding: 1px 0 0 0;
  }
`;

export default Producers;
